<template>
  <div class="page-root">
    <h1>
      <span class="font-weight-bold" style="font-family: maplestory">{{ $t("broadcastGame.title") }}</span>
    </h1>
    <p class="text-body-2 grey--text mt-1 mb-3">{{ $t("broadcastGame.subtitle") }}</p>

    <div class="bg-grid">
      <v-card v-for="game in games" :key="game.key" class="bg-card" outlined hover>
        <div class="bg-card__emoji">{{ game.emoji }}</div>
        <div class="bg-card__name">{{ game.name }}</div>
        <div class="bg-card__desc">{{ game.desc }}</div>
        <v-btn v-if="game.to" class="bg-card__btn" rounded depressed color="primary" :to="game.to">
          {{ $t("broadcastGame.play") }}
        </v-btn>
        <v-btn v-else class="bg-card__btn" rounded depressed disabled>{{ $t("common.comingSoon") }}</v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "BroadcastGamePage",
  computed: {
    // 방송게임 목록. to가 있으면 활성, 없으면 준비중.
    games() {
      return [
        {
          key: "wordGuess",
          emoji: "💬",
          name: this.$t("broadcastGame.wordGuessName"),
          desc: this.$t("broadcastGame.wordGuessDesc"),
          to: null, // 추후 구현
        },
      ];
    },
  },
};
</script>

<style scoped>
.page-root {
  padding: 24px 28px;
}
.bg-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  padding-top: 4px;
}
.bg-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 16px 18px;
  border-radius: 14px;
}
.bg-card__emoji {
  font-size: 44px;
}
.bg-card__name {
  font-size: 15px;
  font-weight: 700;
}
.bg-card__desc {
  font-size: 12px;
  color: #8a8699;
  text-align: center;
  min-height: 32px;
}
.bg-card__btn {
  margin-top: 6px;
  width: 100%;
  font-weight: 700 !important;
}
</style>
